import { createMiddleware } from '@shared/redux';
import { getObjectSelectedData, getTypeOfSelectedObject } from '@domain/object-selected';
import { getEntityId } from '@shared/utils/entity';
import {
    getDashboardFilters, getStartDateFromComparison, getEndDateFromComparison,
} from '@domain/dashboard/dashboard-filters/dashboard-filters.state';
import { toApiDateFormat } from '@shared/utils/date';
import { getComparisonCampaignsReportsStats, HANDLE_GET_COMPARISON_CAMPAIGNS } from './comparison-campaigns.state';

export const comparisonCampaignsMiddleware = createMiddleware({
    [HANDLE_GET_COMPARISON_CAMPAIGNS]: (state) => {
        const dashboardFilters = getDashboardFilters(state);
        const { ranges } = dashboardFilters;

        if (!ranges.comparisonDate) return [];
        const params = getComparisonCampaignStatsParams(state);

        return [getComparisonCampaignsReportsStats(params)];
    },
});

export const getComparisonCampaignStatsParams = (state) => {
    const objectSelected = getObjectSelectedData(state);
    const dashboardFilters = getDashboardFilters(state);
    const { conversionType } = dashboardFilters;

    return {
        customerType: getTypeOfSelectedObject(objectSelected),
        customerId: getEntityId(objectSelected),
        isNewOverview: true,
        conversionType,
        startDate: toApiDateFormat(getStartDateFromComparison(dashboardFilters)),
        endDate: toApiDateFormat(getEndDateFromComparison(dashboardFilters)),
    };
};
